var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTailwind(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 154,
    viewBox: "0 0 256 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128 0C93.8667 0 72.5333 17.0667 64 51.2C76.8 34.1333 91.7333 27.7333 108.8 32C118.537 34.4344 125.497 41.4986 133.201 49.3184C145.751 62.0568 160.275 76.8 192 76.8C226.133 76.8 247.467 59.7333 256 25.6C243.2 42.6667 228.267 49.0667 211.2 44.8C201.463 42.3656 194.503 35.3015 186.799 27.4816C174.249 14.7432 159.725 0 128 0ZM64 76.8C29.8667 76.8 8.53333 93.8667 0 128C12.8 110.933 27.7333 104.533 44.8 108.8C54.5375 111.234 61.4974 118.299 69.2011 126.118C81.7508 138.857 96.2754 153.6 128 153.6C162.133 153.6 183.467 136.533 192 102.4C179.2 119.467 164.267 125.867 147.2 121.6C137.463 119.166 130.503 112.101 122.799 104.282C110.249 91.5432 95.7246 76.8 64 76.8Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -7.11111,
    y1: 49.152,
    x2: 213.987,
    y2: 176.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2298BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0ED7B5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailwind);
export default __webpack_public_path__ + "static/media/tailwind.254c48658eac1b5c8fb5cd4bba5df5b4.svg";
export { ForwardRef as ReactComponent };